<template>
  <img
    v-if="lazyLoad"
    class="AcspImage lazyLoad"
    v-lazy="imgSrc"
    :key="imgSrc"
    v-bind="$attrs"
    v-on="$listeners"
  />
  <img
    v-else
    class="AcspImage"
    :src="imgSrc"
    :key="imgSrc"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
/*
 * 基于vue-lazyload插件封装的image组件
 * */
export default {
  name: "AcspImage",
  components: {},
  props: {
    src: { type: String, default: "" },
    lazyLoad: { type: Boolean, default: false }, //是否懒加载，默认：false
  },
  data() {
    return {};
  },
  created: function () {},
  mounted: function () {},
  updated: function () {},
  methods: {},
  computed: {
    imgSrc: function () {
      //为了保证图片src不为null，这样img:after能显示
      return this.src ? this.src : "";
    },
  },
};
</script>

<style lang="less" scoped>
.AcspImage {
  position: relative;
  display: inline-block;
  font-family: "Helvetica";
  font-weight: 300;
  line-height: 0;
  color: transparent;
  overflow: hidden;
}

.AcspImage:before {
  display: block;
}

.AcspImage:after {
  display: block;
  position: absolute;
  content: " ";
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #eeedeb;
  box-sizing: border-box;
  z-index: 2;
  font-size: 16px;
}

.AcspImage.lazyLoad {
  background-color: #eeedeb;
}

.AcspImage.lazyLoad[lazy="loading"] {
  background-position: center center;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.AcspImage.lazyLoad[lazy="error"] {
  background-color: #eeedeb;
  box-sizing: border-box;
}

.AcspImage.lazyLoad[lazy="loaded"] {
  background-color: transparent;
  background-image: none !important;
  animation: 0.8s fadeInOut ease;
}

@keyframes fadeInOut {
  0% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.75;
  }
  100% {
    opacity: 1;
  }
}
</style>
